module.exports = __webpack_public_path__ + "static/media/benef_noactivos_red.54f57958.png";